// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"39c49806","455":"13a7c6e2","977":"d2dd7a9b"}[chunkId] + ".chunk.js";
};